import React from 'react';

export interface ScoreStatusInfo {
  text: string;
  statusColor: string;
  backgroundColor: string;
  borderRadius: string;
  color: string;
  fontWeight: number;
  padding: string;
}

export const scoreStatusMap: Record<string, ScoreStatusInfo> = {
  MANUAL_APPROVED: {
    text: 'Aprovado manualmente',
    statusColor: '#55A94E',
    backgroundColor: '#EEFBEE',
    borderRadius: '4px',
    color: '#55A94E',
    fontWeight: 500,
    padding: '8px 16px',
  },
  AUTO_APPROVED: {
    text: 'Aprovado automaticamente',
    statusColor: '#EEFBEE',
    backgroundColor: '#41840D',
    borderRadius: '4px',
    color: '#FFFFFF',
    fontWeight: 500,
    padding: '8px 16px',
  },
  WAITING_APPROVAL: {
    text: 'Aguardando análise',
    statusColor: '#FFFFFF',
    backgroundColor: '#FF9902',
    borderRadius: '4px',
    color: '#FFFFFF',
    fontWeight: 500,
    padding: '8px 16px',
  },
  MANUAL_REJECTED: {
    text: 'Reprovado manualmente',
    statusColor: '#DC3545',
    backgroundColor: '#FFF4F4',
    borderRadius: '4px',
    color: '#DC3545',
    fontWeight: 500,
    padding: '8px 16px',
  },
  AUTO_REJECTED: {
    text: 'Reprovado automaticamente',
    statusColor: '#FFFFFF',
    backgroundColor: '#D70208',
    borderRadius: '4px',
    color: '#FFFFFF',
    fontWeight: 500,
    padding: '8px 16px',
  },
  UNAVAILABLE: {
    text: 'Status análise não disponível',
    statusColor: '#000000',
    backgroundColor: '#FFFFFF',
    borderRadius: '4px',
    color: '#000000',
    fontWeight: 500,
    padding: '8px 16px',
  },
  default: {
    text: 'Status análise não disponível',
    statusColor: '#000000',
    backgroundColor: '#FFFFFF',
    borderRadius: '4px',
    color: '#000000',
    fontWeight: 500,
    padding: '8px 16px',
  },
};

interface ScoreStatusBadgeProps {
  status: string | null | undefined;
}

export const ScoreStatusBadge: React.FC<ScoreStatusBadgeProps> = ({ status }) => {
  const statusInfo = status ? scoreStatusMap[status] || scoreStatusMap.default : scoreStatusMap.default;

  if (!statusInfo.text) return null;

  return (
    <div
      style={{
        backgroundColor: statusInfo.backgroundColor,
        padding: statusInfo.padding,
        borderRadius: statusInfo.borderRadius,
        color: statusInfo.color,
        fontWeight: statusInfo.fontWeight,
        display: 'inline-block',
        margin: '4px',
      }}
    >
      {statusInfo.text}
    </div>
  );
};
